import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../../../Services/translation';
import { signUpForNewsletter } from '../../../Actions/Footer.action';

const NewsLetterSection = () => {

    const dispatch = useDispatch();

    const { newsLetterSignUpTitle,
        newsLetterSignUpText,
        newsLetterSignUpButtonText,
        signupDone, 
        newsLetterSignUpInformationText } = useSelector((state) => state.footer);

    const handleKeyDown = (event) => {
        if (event.keyCode === 13) {
            submitForm();
        }
    }
    const gdprWarning = translate('newsletter.complywithgdpr.warning');
    const signupError = translate('newsletter.signup.error');

    const submitForm = () => {
        if (checked === true) {
            setErrorMessage('');
            dispatch(signUpForNewsletter(email)).then((succeeded) => {
                if (!succeeded) {
                    setErrorMessage(signupError);
                }
            });
        }
        else {
            setErrorMessage(gdprWarning);
        }
    }

    const [email, setEmail] = useState();

    const [checked, setChecked] = useState(false);

    const [errorMessage, setErrorMessage] = useState('');

    const handleChange = () => {
        setChecked(!checked);
    };

    return (
        <section className="newsletter-row">
            <div className="row">
                <span className="newsletter-row__title footer__title">{newsLetterSignUpTitle}</span>
                <p className="newsletter-row__text">{newsLetterSignUpText}</p>
                {!signupDone ? <div className="newsletter-row__input-wrapper">
                    <input className="form__input" onKeyDown={handleKeyDown} placeholder={translate('newsletter.email')} onChange={(event) => setEmail(event.target.value)} />
                    <button className="button" onClick={() => submitForm()}>
                        {newsLetterSignUpButtonText}
                    </button>
                    <div className="newsletter-row__comply-with-gdpr">
                        {errorMessage && (
                            <p className="newsletter-row__comply-with-gdpr__error">{errorMessage}</p>
                        )}
                        <span className="newsletter-row__comply-with-gdpr__input-container">
                        <input
                            className="newsletter-row__comply-with-gdpr__input"
                            type="checkbox"
                            id="complywithgdpr"
                            checked={checked}
                            onChange={handleChange}
                            />
                        </span>
                        <label
                            className="newsletter-row__comply-with-gdpr__label"
                            htmlFor="complywithgdpr"
                            dangerouslySetInnerHTML={{ __html: newsLetterSignUpInformationText.value }}
                        >  
                        </label>
                    </div>
                </div>
                    :
                    <div>
                        <p className="newsletter-row__confirmation">{translate('newsletter.signup.confirmation')}</p>
                    </div>

                }
            </div>

        </section>
    )
};
export default NewsLetterSection;